export default __webpack_public_path__ + "static/opdemo2-tutor-screen-936c435864a2df7c42f6866da2211f09.png";